export const UserManagementDataLayerSymbol = Symbol.for("UserManagementDataLayerSymbolF");
